import { Helmet } from 'react-helmet';
import { SITE, getMetadata, getStructuredData, serializeSchema } from '../seo/metadata';

export default function SEO(props) {
  const meta = getMetadata(props);
  return (
    <Helmet>
      <title>{meta.fullTitle}</title>
      <meta name="description" content={meta.description} />
      <meta name="robots" content={meta.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large'} />
      <link rel="canonical" href={meta.canonical} />
      <meta property="og:type" content={meta.type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:url" content={meta.canonical} />
      <meta property="og:title" content={meta.fullTitle} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={SITE.imageAlt} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={meta.canonical} />
      <meta name="twitter:title" content={meta.fullTitle} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />
      <meta name="twitter:image:alt" content={SITE.imageAlt} />
      <script id="site-structured-data" type="application/ld+json">{serializeSchema(getStructuredData(meta, props.article))}</script>
    </Helmet>
  );
}
